import {Icon} from '@udemy-v2/icons';
import {BlockList} from '@udemy-v2/react-core-components';
import {Accordion} from '@udemy-v2/react-reveal-components';
import React from 'react';

import {useDeviceType} from '@udemy-v2/hooks';
import {useI18n} from '@udemy-v2/i18n';

import './course-requirements.module.scss';

interface RequirementsProps {
    prerequisites: string[];
    isCollapsible?: boolean;
    className?: string;
    titleTypography?: 'ud-heading-lg' | 'ud-heading-xl';
    onAccordionToggle?: () => void;
}

export function Requirements({
    prerequisites = [],
    isCollapsible = false,
    className = 'component-margin',
    titleTypography = 'ud-heading-xl',
    onAccordionToggle,
}: RequirementsProps) {
    const getAccordionSize = () => {
        switch (titleTypography) {
            case 'ud-heading-lg':
                return 'large';
            case 'ud-heading-xl':
            default:
                return 'xlarge';
        }
    };

    const {gettext} = useI18n();
    const deviceType = useDeviceType();

    if (!prerequisites.length) {
        return null;
    }

    const title = gettext('Requirements');
    const requirements = prerequisites.map((item: string, index: number) => (
        <BlockList.Item
            key={`requirement-${item}-${index}`}
            icon={<Icon glyph="bullet" label="" />}
        >
            {item}
        </BlockList.Item>
    ));

    const shouldCollapse = deviceType === 'mobile' || isCollapsible;

    if (!shouldCollapse) {
        return (
            <div className={className}>
                <h2 data-purpose="requirements-title" className={`title ${titleTypography}`}>
                    {title}
                </h2>
                <BlockList size="small" padding="tight">
                    {requirements}
                </BlockList>
            </div>
        );
    }

    return (
        <Accordion size={getAccordionSize()} className={className}>
            <Accordion.Panel title={title} onToggle={onAccordionToggle}>
                <BlockList size="small" padding="tight">
                    {requirements}
                </BlockList>
            </Accordion.Panel>
        </Accordion>
    );
}
